export default "__VITE_ASSET__a5857672__"